module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst additionalAttributes = []\nconst additionalClasses = []\nif(config.bootstrapVersion && (model.atom.renderType === 'checkbox' || model.atom.renderType === 'toggle')){\nadditionalClasses.push('form-check-label')\n}\nadditionalAttributes.push(`class=\"${additionalClasses.join(' ')}\"`)\nif(model.labelTitle){\nadditionalAttributes.push(`title=\"${model.labelTitle}\"`)\n}\n%><label <%- additionalAttributes.join(' ') %>>\n<%= (model && model.label ? model.label : 'label not found in user lang') %>\n</label>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\elements\\label.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const additionalAttributes = []
const additionalClasses = []
if(config.bootstrapVersion && (model.atom.renderType === 'checkbox' || model.atom.renderType === 'toggle')){
additionalClasses.push('form-check-label')
}
additionalAttributes.push(`class="${additionalClasses.join(' ')}"`)
if(model.labelTitle){
additionalAttributes.push(`title="${model.labelTitle}"`)
}

    ; __line = 11
    ; __append("<label ")
    ; __append( additionalAttributes.join(' ') )
    ; __append(">\n")
    ; __line = 12
    ; __append(escapeFn( (model && model.label ? model.label : 'label not found in user lang') ))
    ; __append("\n</label>")
    ; __line = 13
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\elements\label.ejs

}